let mutations = {
    
    set_spinner(state,boolean){
        state.spinner = boolean
    }
}
export default mutations
